import { z } from 'zod';

export const monitoringDashboardSchema = z
  .object({
    severity: z.enum(['all', 'critical', 'warning', 'info']).default('all'),
    status: z.enum(['all', 'active', 'cleared']).default('active'),
    site: z.string().default('all'),
  })
  .strict()
  .catch({
    severity: 'all',
    status: 'active',
    site: 'all',
  });
